import { JACKPOTS_REDUCER } from '../constants';
import { useCustomSelector } from './useCustomSelector';

import { TJackpotsSelector, TEqualityFunction } from '../types';

export const useJackpotsSelector =
    <TSelected>(selector: TJackpotsSelector<TSelected>, equalityFn?: TEqualityFunction<TSelected>) =>
        useCustomSelector<TSelected, typeof JACKPOTS_REDUCER>(JACKPOTS_REDUCER, selector, equalityFn);
